import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

export const SubjectTypeItem = ({ recordId, isDisabled, onClick, correctionSelected }): JSX.Element => {
    return (
        <li
            className="col-md-6"
            style={{ paddingLeft: 5 + "px", paddingRight: 5 + "px" }}
            onClick={isDisabled ? null : onClick}>
            <input type="radio" name={`SubjectType${recordId}`} value="true" checked={correctionSelected} readOnly disabled={isDisabled} />
            <label>
                <span className="posh-select-icon"><FontAwesomeIcon icon={faPenToSquare} aria-hidden="true" /></span>
                <span className="posh-select-body">
                    <span className="posh-select-title">Change Subject Type</span>
                    <span className="posh-select-description text-muted">Change the subject type for a single subject.</span>
                </span>
            </label>
        </li>
    );
}
